import * as Sentry from '@sentry/browser';

import '@src/helpers/publicPath';
import { get as getItem } from '@src/helpers/localStorage';

import { STORAGE_KEY } from '@src/helpers/fritsAuth';

/**
 * Sentry entry. Not used by nuxt.
 */

function retrieveTokenHeader() {
  return getItem(STORAGE_KEY, '');
}

function setupSentry({ sentryDsn, sentryEnvName, sentryDelivery, sentryOrigin }) {
  Sentry.init({
    dsn: sentryDsn,
    release: process.env.VERSION,
    environment: sentryEnvName,
    beforeSend(event, hint) {
      // eslint-disable-next-line no-console
      console.error(hint.originalException || hint.syntheticException);

      // drop event on development
      if (sentryDelivery === false)
        return null;

      return event;
    },
  });

  setDossierId(Sentry);

  // Set domain/origin
  Sentry.configureScope((scope) => {
    scope.setTag('origin', sentryOrigin);
  });
}

function setDossierId(sentry) {
  const dossierId = getDossierId();

  if (!dossierId)
    return;

  // Get dossier_id from local storage
  sentry.configureScope((scope) => {
    scope.setUser({
      dossier_id: dossierId,
    });
  });
}

// CBHS token auth
function getDossierId() {
  const token = retrieveTokenHeader();

  if (!token)
    return false;

  return token.split('-').pop();
}

(({
  sentryDsn = global.fritsVueEnvironment?.sentry.dsn ?? process.env.SENTRY_DSN,
  sentryEnvName = global.fritsVueEnvironment?.sentry.envName ?? process.env.SENTRY_ENV_NAME,
  sentryDelivery = global.fritsVueEnvironment?.sentry.delivery ?? true,
  assetsPath,
}) => {
  const envDomain = process.env.DOMAIN ? `https://${process.env.DOMAIN}` : null;
  const assetsUrl = new URL(assetsPath ?? envDomain ?? global.location);

  setupSentry({
    sentryDsn,
    sentryEnvName,
    sentryDelivery,
    sentryOrigin: assetsUrl.origin,
  });
})(global.fritsAppOptions || {});
